import React, { FC, PropsWithChildren } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { ColorFunction } from '@styles/colors/types';
import { fullHeight, fullWidth, height, scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import { useNavigation, useRoute } from '@react-navigation/native';
import { isWeb, navigateTo } from '@helpers';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { OperatorPanelSettingsWrapperContext } from '@components/operatorPanel/components/OperatorPanelSettings/components/OperatorPanelSettingsWrapper';

export interface RootProps extends PropsWithChildren {
  C: ColorFunction;
  containerStyles?: StyleProp<ViewStyle>;
  scale?: ScaleFunction;
  font?: typeof initialFont;
}

const Root: FC<RootProps> = ({ children, C, containerStyles, scale = initialScale, font = initialFont }) => {
  const navigation = useNavigation();
  const route = useRoute();

  const onDefaultClose = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
      return;
    }
    navigateTo('OperatorPanelSettings', { id: route?.params?.id });
  };

  const isLight = C.scheme === 'light';
  const mainBg = C(`Background/${isLight ? 'Light' : 'Dark'}/Panel [mobile]`, false);

  return (
    <OperatorPanelSettingsWrapperContext.Provider value={{ C, scale, font, onDefaultClose }}>
      <View
        style={[
          {
            backgroundColor: mainBg,
            height: isWeb ? fullHeight : height - 22,
            position: 'absolute',
            top: isWeb ? 0 : 22,
            width: fullWidth,
          },
          containerStyles,
        ]}
      >
        {children}
      </View>
    </OperatorPanelSettingsWrapperContext.Provider>
  );
};

export default Root;
